import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { GlobalService } from 'src/app/core/services/global.service';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import { AuthService } from '../services/auth.service';
import { AlertHandler } from 'src/app/core/handlers/alert-handler';

export const routeGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean => {
  // const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const router = inject(Router);

  // to shift page to next avalable permitted page
  // return authService.fetchScreenAccessData().pipe(
  //   map(({ user_screens }: any) => {
  //     if (user_screens.length === 0) {
  //       AlertHandler.ErrorAlert(MessageHandler.NO_SCREEN_ACCESS);
  //       globalService.deleteUserSession();
  //       router.navigate(['auth/logout']);
  //     }
  //     user_screens = user_screens.sort(function (a, b) {
  //       return a.screen_id - b.screen_id;
  //     });
  //     globalService.updateUserScreenMapping(user_screens);
  //     const activeUrl = globalService.permittedScreen(state.url);

  //     if (state.url === activeUrl) {
  //       return true;
  //     } else {
  //       router.navigate([activeUrl]);
  //       return false;
  //     }
  //   })
  // );

  const activeUrl = globalService.permittedScreen(state.url);
  if (!activeUrl) {
    AlertHandler.ErrorAlert(MessageHandler.NO_SCREEN_ACCESS);
    globalService.deleteUserSession();
    router.navigate(['auth/logout']);
  }

  if (state.url === activeUrl) {
    return true;
  } else {
    router.navigate([activeUrl]);
    return false;
  }
  // return true;
};

export const routeChildGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const globalService = inject(GlobalService);
  const router = inject(Router);
  const activeUrl = globalService.permittedScreen(state.url, route.routeConfig.path);

  if (state.url === activeUrl) {
    return true;
  } else {
    router.navigate([activeUrl]);
    return false;
  }
};
